import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { useLocation } from "react-router-dom";
import tw from "twin.macro";
import { LogoLink } from "components/headers/light.js";
import logo from "images/company-logo.png";

/*
 * The Cyber Leeway header, shared by the landing page and the inner (legal) pages so they always
 * look identical. On the landing page the links scroll smoothly to the section; on any other page
 * they go back to that section of the landing page.
 */
const NavRow = tw.div`flex flex-col lg:flex-row items-center justify-between`;
const NavLink = tw.a`mt-4 lg:mt-0 transition duration-300 font-medium pb-1 border-b-2 mr-12 text-gray-700 border-gray-400 hocus:border-gray-700`;
const PrimaryNavLink = tw(
  NavLink
)`text-gray-100 bg-primary-500 px-6 py-3 border-none rounded hocus:bg-primary-900 focus:shadow-outline mt-6 md:mt-4 lg:mt-0`;
const Links = tw.div`flex flex-wrap justify-center lg:justify-end items-center -mr-12`;
const LineBreak = tw.div`md:hidden flex-100 h-0`;
const LogoImg = tw.img`w-16!`;

export default () => {
  const onHome = useLocation().pathname === "/";
  const link = (id) => (onHome ? { as: AnchorLink, href: `#${id}` } : { href: `/#${id}` });

  return (
    <NavRow>
      <LogoLink href="/">
        <LogoImg src={logo} alt="Cyber Leeway logo" />
        CYBER LEEWAY
      </LogoLink>
      <Links>
        <NavLink {...link("services")}>Services</NavLink>
        <NavLink {...link("about")}>About Us</NavLink>
        <LineBreak />
        <PrimaryNavLink {...link("contact")}>Contact Us</PrimaryNavLink>
      </Links>
    </NavRow>
  );
};
